export const emailReminderModel = [
    { value: '3', label: '3 days' },
    { value: '7', label: '7 days' },
];
